<template>
  <div class="flex flex-row justify-center items-center my-6">
    <div class="grid grid-cols-2 sm:grid-cols-4 gap-5">
      <div>
        <img
          class="w-full h-auto"
          src="@/assets/images/receipt-examples/correct.png"
          :alt="$t(texts.correct)"
        />
        <div class="text-center">{{ $t(texts.correct) }}</div>
      </div>
      <div>
        <img
          class="w-full h-auto"
          src="@/assets/images/receipt-examples/not-readable.png"
          :alt="$t(texts.notReadable)"
        />
        <div class="text-center">{{ $t(texts.notReadable) }}</div>
      </div>
      <div>
        <img
          class="w-full h-auto"
          src="@/assets/images/receipt-examples/folded.png"
          :alt="$t(texts.folded)"
        />
        <div class="text-center">{{ $t(texts.folded) }}</div>
      </div>
      <div>
        <img
          class="w-full h-auto"
          src="@/assets/images/receipt-examples/cropped.png"
          :alt="$t(texts.cropped)"
        />
        <div class="text-center">{{ $t(texts.cropped) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'receipt-examples',
  props: {
    texts: {
      type: Object,
      default: () => ({
        correct: 'Valid',
        notReadable: 'Not readable',
        folded: 'Folded',
        cropped: 'Cropped'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
